/**
 * The only type a consumer provides: a thing in time. Lives in time-space and
 * is never mutated by the timeline. (Editor vocabulary: an *item* is placed
 * on a *track* — a horizontal lane — as a *clip*; see `layout.ts`.)
 */
import type { TimeWindow } from "./window";

export interface TimelineTrackItem<T> {
  /** Unique within the timeline. */
  id: string;
  /** Display label; the consumer decides what an untitled item reads as. */
  label: string;
  /** Milliseconds since the epoch. */
  startTime: number;
  /** Milliseconds since the epoch; `>= startTime`. */
  endTime: number;
  /** The original record, passed through to callbacks untouched. */
  data: T;
}

/**
 * The items that overlap `window`, including ones straddling its edges. What
 * a `FetchItems` built over an in-memory list returns.
 */
export function itemsOverlapping<T>(
  items: readonly TimelineTrackItem<T>[],
  window: TimeWindow,
): readonly TimelineTrackItem<T>[] {
  return items.filter(
    (item) => item.endTime >= window.start && item.startTime <= window.end,
  );
}
